<script setup>
import {onMounted, ref} from 'vue'
import CustomMenu from "@/components/NewPC/CustomMenu.vue";
import CustomLeftMenu from "@/components/NewPC/CustomLeftMenu.vue";
import LeftLightning from "@/components/NewPC/LeftLightning.vue";
import RightLightning from "@/components/NewPC/RightLightning.vue";
import {showImagePreview, Swipe, SwipeItem} from "vant";
import {getArticles} from "@/api/common";
import {useRouter} from "vue-router";
import GiftEntry from "@/components/NewPC/GiftEntry.vue";
import {useTgaStore} from "@/store/tga";
import useAccount from "@/store/account";
const tga = useTgaStore()
const accountStore = useAccount();
const router = useRouter();
const tabs = ref(0);
const articles = ref([]);

const handleChangeContent = (index) => {
  if (index == tabs.value) return
  tabs.value = index;
}

const imgsMap = {
  wutu_1bz: require('@/assets/newPc/wutu/1-bz.png'),
  wutu_1yt: require('@/assets/newPc/wutu/1-yuantu.jpg'),
  wutu_2bz: require('@/assets/newPc/wutu/2-bz.png'),
  wutu_2yt: require('@/assets/newPc/wutu/2-yuantu.jpg'),
  wutu_3bz: require('@/assets/newPc/wutu/3-bz.png'),
  wutu_3yt: require('@/assets/newPc/wutu/3-yuantu.jpg'),
  wutu_4bz: require('@/assets/newPc/wutu/4-bz.png'),
  wutu_4yt: require('@/assets/newPc/wutu/4-yuantu.jpg'),
  wutu_5bz: require('@/assets/newPc/wutu/5-bz.png'),
  wutu_5yt: require('@/assets/newPc/wutu/5-yuantu.jpg'),
}

const imgList = [imgsMap.wutu_1bz, imgsMap.wutu_2bz, imgsMap.wutu_3bz, imgsMap.wutu_4bz, imgsMap.wutu_5bz ];
const originImg = [imgsMap.wutu_1yt, imgsMap.wutu_2yt, imgsMap.wutu_3yt, imgsMap.wutu_4yt, imgsMap.wutu_5yt]

const WallpaperSwipeRef = ref(null);
const swiperIndex = ref(0);
const swipeChange = index => {
  swiperIndex.value = index;
}
const swipeJump = (item, index) => {
  if (index == swiperIndex.value) return;
  item.swipeTo(index)
}
const swipeTo = (item, type) => {
  if (type == 'next') {
    item.next();
  } else {
    item.prev();
  }
}

const handleShowImg = (index) => {
  showImagePreview({
    images: [originImg[index]],
    closeable: true
  });
}

const handleDownload = index => {
  // 创建一个 <a> 元素
  const a = document.createElement('a');
  a.href = originImg[index];
  a.download = 'downloaded-image.jpg'; // 设置下载的文件名
  // 触发点击事件
  a.click();
}

const fetchArticles = () => {
  getArticles({type: 2}).then((res) => {
    console.log(res);
    if (res.status == 200 && res.data && res.data.code == 0) {
      articles.value = res.data.data;
    }
  })
}

const handleJumpDetail = row => {
  window.open(`${window.location.origin}/news-detail?id=${row.id}&type=2`);
}
const handleJumpHome = () => {
  router.push('/')
}
onMounted(() => {
  fetchArticles()

  tga.tgaLogin("202504_GUANWANG", accountStore.getterAccount() ? accountStore.getterAccount():'未绑定');
  // 用户存在，上报
  tga.tgaTrack('web_campaigns_event', {
    web_campaigns_op: 'pc_page_exposure',
    account: accountStore.getterAccount() ? accountStore.getterAccount():'未绑定',
    gps1: accountStore.getterAccount() ? accountStore.account.invite_code:null,
    gps2: "玩家中心"
  })
})
</script>

<template>
<div class="player_center">
  <custom-menu :active="2" />

  <div class="content">
    <img src="@/assets/newPc/topup/topup_logo.png" @click="handleJumpHome" alt="" class="logo_icon">
    <div class="strategy_block" v-if="tabs == 0">
      <div class="articles_item" v-for="item of articles" @click="handleJumpDetail(item)">
        <div>
          <div class="title">{{ item.title }}</div>
          <div class="other">{{ item.time }}</div>
        </div>
        <img :src="item.cover" alt="">
      </div>
    </div>

    <div class="wallpaper_block" v-if="tabs == 1">
      <swipe class="swipe" ref="WallpaperSwipeRef" :show-indicators="false"  @change="swipeChange">
        <swipe-item class="swipe_item" v-for="(item, index) of imgList">
          <div class="img_block">
            <img :src="item" alt="">
            <div class="btn_block">
              <button @click="handleShowImg(index)">查看原图</button>
              <button @click="handleDownload(index)">下载原图</button>
            </div>
          </div>
        </swipe-item>
      </swipe>

      <img class="swipe_left_icon" @click="swipeTo(WallpaperSwipeRef, 'prev')" src="@/assets/newPc/player/swipe_left_icon.png" alt="" />
      <img class="swipe_right_icon" @click="swipeTo(WallpaperSwipeRef, 'next')" src="@/assets/newPc/player/swipe_right_icon.png" alt="" />

      <div class="dots">
        <div v-for="(item, index) of imgList" @click="swipeJump(WallpaperSwipeRef, index)" :class="{'active': index == swiperIndex}"></div>
      </div>
    </div>



    <custom-left-menu type="PlayerCenter" @on-click="handleChangeContent" class="left_menu" />
    <gift-entry class="gift_entry" />
    <left-lightning class="left_lightning" />
    <right-lightning class="right_lightning" />
  </div>


</div>
</template>

<style scoped lang="scss">
.player_center {
  width: 100vw;
  height: 100vh;
  background: transparent url("@/assets/newPc/page_bg.png") no-repeat center center;
  background-size: cover;

  .content {
    width: 100vw;
    height: 100vh;
    background: transparent url("@/assets/newPc/player_center_bg.png") no-repeat top center;
    background-size: contain;
    position: relative;
    display: flex;
    justify-content: center;
    padding-top: 13.4375vw;
    box-sizing: border-box;

    .logo_icon {
      position: absolute;
      left: 2.265625vw;
      top: 2.03125vw;
      width: 7.3046875vw;
      height: 4.0234375vw;
    }

    .strategy_block {
      width: 53.75vw;
      height: 29.1015625vw;
      position: relative;
      z-index: 1;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 1.5234375vw 0 1.5234375vw 1.2109375vw;
      box-sizing: border-box;
      background-color: #EEF4FF;

      .articles_item {
        width: 50.625vw;
        height: 6.9140625vw;
        background-color: #fff;
        margin-bottom: 1.2109375vw;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 0.5859375vw;
        box-sizing: border-box;

        &:last-child {
          margin-bottom: 0;
        }

        div {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .title {
          font-family: 'SourceHanSansCN-Medium';
          font-size: 1.09375vw;
          color: #555;
          cursor: pointer;
        }

        .other {
          font-family: 'SourceHanSansCN-Regular';
          color: #A9A9A9;
          font-size: 0.78125vw;
          cursor: pointer;
        }

        img {
          margin-left: 0.78125vw;
          flex: none;
          width: 13.4375vw;
          height: 5.703125vw;
          cursor: pointer;
        }
      }
    }



    .wallpaper_block {
      width: 55.2734375vw;
      height: 29.296875vw;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      z-index: 1;

      .swipe {
        width: 55.2734375vw;
        height: 29.296875vw;

        .swipe_item {
          width: 55.2734375vw;
          height: 29.296875vw;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: default;


          img {
            width: 48.359375vw;
            height: 23.046875vw;
          }


          .img_block {
            width: 51.484375vw;
            height: 26.25vw;
            background: transparent url("@/assets/newPc/wutu_img_bg.png") no-repeat center center;
            background-size: contain;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;

            .btn_block {
              position: absolute;
              bottom: 4.609375vw;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              left: 0;
              right: 0;

              button {
                width: 7.96875vw;
                height: 2.421875vw;
                color: #fff;
                font-family: 'SourceHanSansCN-Bold';
                font-size: 0.9375vw;
                border: none;
                margin-right: 2.34375vw;
                background: transparent url("@/assets/newPc/wutu/wutu_btn_1.png") no-repeat center center;
                background-size: contain;
                cursor: pointer;

                &:last-child {
                  margin-right: 0;
                  background: transparent url("@/assets/newPc/wutu/wutu_btn_2.png") no-repeat center center;
                  background-size: contain;
                }
              }
            }


            img {
              width: 48.359375vw;
              height: 23.046875vw;
            }

            &:before {
              content: '';
              position: absolute;
              top: -1.328125vw;
              left: -1.9140625vw;
              display: block;
              width: 52.265625vw;
              height: 27.5vw;
              background: transparent url("@/assets/newPc/wutu_bg_1.png") no-repeat center center;
              background-size: cover;
              z-index: -1;
            }
            &:after {
              content: '';
              position: absolute;
              top: -1.328125vw;
              right: -1.9140625vw;
              display: block;
              width: 53.0859375vw;
              height: 29.296875vw;
              background: transparent url("@/assets/newPc/wutu_bg_2.png") no-repeat center center;
              background-size: cover;
              z-index: -1;
            }

          }
        }
      }


      .swipe_right_icon, .swipe_left_icon {
        width: 3.1640625vw;
        height: 4.8046875vw;
        position: absolute;
        top: 11.3671875vw;
        z-index: 1;
        cursor: pointer;
      }

      .swipe_right_icon {
        right: -5.5859375vw;
      }

      .swipe_left_icon {
        left: -5.5859375vw;
      }

      .dots {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        position: absolute;
        bottom: -0.78125vw;

        div {
          width: 0.859375vw;
          height: 0.859375vw;
          background-color: #4E58E4;
          border-radius: 50%;
          margin-right: 1.9140625vw;
          cursor: pointer;

          &:last-child {
            margin-right: 0;
          }

          &.active {
            width: 1.4453125vw;
            height: 0.859375vw;
            background-color: #E8FF24;
            border-radius: 50%;
          }
        }
      }

    }


    .left_menu {
      position: absolute;
      top: 16.09375vw;
      left: 3.0078125vw;
      z-index: 1;
    }

    .gift_entry {
      position: absolute;
      top: 29.5703125vw;
      right: 1.640625vw;
      z-index: 1;
    }

    .left_lightning {
      position: absolute;
      left: 0;
      top: 28.59375vw;
    }

    .right_lightning {
      position: absolute;
      right: 0;
      top: 8.671875vw;
    }
  }


}
</style>